<template>
	<div class="case1">
		<div class="case1-c">
			<div class="case1-info">
				<div class="navs">
					<div class="item" :class="selectIndex==index?'selectItem':''" v-for="(item, index) in list1" :key="index"
					@click="tapList(index)">  
						{{item}}
					</div>
				</div>
				
				<div class="list">
					<div class="item" style="cursor: pointer;" v-for="(item, index) in list" :key="index"  @click="handlePreview(item.profile)">
						<img :src="item.profile"  alt=""><!-- style="object-fit: contain;" -->
						<div>{{item.caseName}}</div>
					</div>
				</div>
				
				<div class="pagebox">
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="total">
					</el-pagination>
				</div>
				
				
				
			</div>
		</div>
		
	    <div v-if="isShowImg" class="preImg">
	    	<img :src="showImg" alt="" @click="closeViewer"/>
	    </div>
		
	</div>
</template>

<script>
	export default {
		props: {
			list:{
				type:Array,
				default:[]
			},
			selectIndex:{
				type:Number,
				default:0
			},
			total:{
				type:Number,
				default:0
			}
		},
		data() {
			return {
				// selectIndex:0,
				list1:["光伏", "风电", "电力", "储能"],
				isShowImg:false,
				showImg:"",

			}
		},
		created() {

		},
		methods: {
			tapList(index) {
				// this.selectIndex = index
				this.$emit("changeCaseType", index)
			},
			
			handlePreview(url) {
				this.showImg = url
			      this.isShowImg = true
			    },
			    // 关闭查看器
			    closeViewer() {
			      this.isShowImg = false
			    },
			// caseType

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}
	
	.preImg {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 9999;
		img {
			width: 70%;
			height: 90%;
			object-fit: contain;
			cursor: pointer;
		}
	}

	.case1 {

		.case1-c {
			background-color: white;
			display: flex;
			justify-content: center;
			.case1-info {
				
				.navs {
					justify-content: center;
					align-items: center;
					.item {
						box-sizing: border-box;
						color: #332C2B;
					}
					.selectItem {
						color: #22A3D3;
						text-align: center;
					}
				}
				
				.list {
					
					
					align-items: center;
					flex-wrap: wrap;
					.item {
						transition: transform 0.3s;
						div {
							color: #332C2B;
						}
					}
					.item:hover {
       transition: width 0.3s, height 0.3s;
       transform: scale(0.95);
       
      }

					
				}
				
			}
		}
	
	    .pagebox {
	    	justify-content: center;
	    	
	    }
	
	}
	
	@media screen and (min-width: 1200px) {
		.case1 {
			width: 100%;
			.case1-c {
				width: 100%;
				display: flex;
				padding: 80px 0 100px;
				.case1-info {
					width: 1240px;
					padding: 0 40px;	
					
					.navs {
						width: 100%;
						padding: 0 20px;
						display: flex;
						.item {
							width: 65px;
							height: 70px;
							line-height: 70px;
							margin-left: 40px;
							margin-right: 40px;
							font-size: 26px;
						}
						.selectItem {
							font-size: 26px;
							border-bottom: 2px solid #22A3D3;
						}
					}
					
					.list {
						padding-left: 20px;
						width: 100%;
						margin-top: 56px;
						display: flex;
						justify-content: flex-start;
						.item {
							width: calc(33.3% - 25px);
							margin-left: 25px;
							img {
								width: 100%;
								// height: 300px;
								height:170px;
							}
							div {
								height: 90px;
								line-height: 90px;
								font-size: 24px;
							}
						}
						
					}
					
				}
			}
		    .pagebox {
		    	display: flex;		    	
		    }
		}
	
	}
	@media screen and (max-width: 1200px) {
		.case1 {
			width: 100%;
			.case1-c {
				width: 100%;
				display: flex;
				padding: 50px 0 70px;
				.case1-info {
					width: 100%;
					padding: 0 20px;	
					
					.navs {
						width: 100%;
						display: flex;
						justify-content: flex-start;
						.item {
							width: 65px;
							height: 60px;
							line-height: 60px;
							margin-left: 24px;
							margin-right: 24px;
							font-size: 20px;
						}
						.selectItem {
							border-bottom: 2px solid #22A3D3;
						}
					}
					
					.list {
						width: 100%;
						margin-top: 40px;
						display: flex;
						.item {
							width: calc(33.3% - 12px);
							margin-left: 12px;
							img {
								width: 100%;
								// height: 270px;
								height:170px;
							}
							div {
								height: 70px;
								line-height: 70px;
								font-size: 20px;
							}
						}
						
					}
					
				}
			}
		    .pagebox {
		    	display: flex;		    	
		    }
		}
	
	}
	@media screen and (max-width: 880px) {
		.case1 {
			width: 100%;
			.case1-c {
				width: 100%;
				display: flex;
				padding: 20px 0 30px;
				.case1-info {
					width: 100%;
					padding: 0 10px;	
					
					.navs {
						width: 100%;
						display: flex;
						.item {
							width: 40px;
							height: 40px;
							line-height: 40px;
							margin-left: 10px;
							margin-right: 10px;
							font-size: 15px;
						}
						.selectItem {
							border-bottom: 2px solid #008D8E;
						}
					}
					
					.list {
						width: 100%;
						margin-top: 20px;
						display: flex;
						justify-content: space-between;
						.item {
							width: calc(50% - 12px);
							img {
								width: 100%;
								// height: 170px;
							}
							div {
								height: 40px;
								line-height: 40px;
								font-size: 15px;
								
								 white-space: nowrap; /* 禁止换行 */
								  overflow: hidden; /* 隐藏溢出内容 */
								  text-overflow: ellipsis; /* 超出部分显示省略号 */
							}
						}
						
					}
					
				}
			}
		    .pagebox {
		    	display: flex;		    	
		    }
		}
	
	}
</style>
